import Footer from "../components/Footer/Footer"
import ContentSingle from "../components/ContentSingle/ContentSingle"

function TVSeries(){

    return(
        <>
        <ContentSingle title="TV Series" type="tv" form="single"/>
        </>
    )
}


export default TVSeries